import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TopupcardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchTopupcardPlans } from "../../../../features/auth/store/topupcardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import TopupCard from "./Topupcard";
import { fetchTopupcardCategories } from "../../../../features/auth/store/topupcardCategorySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";

const ElectricRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedTopupPlan, setSelectedTopupPlan] = useState<Product | null>(
    null,
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { topupcardPlans, loading, error } = useSelector(
    (state: RootState) => state.topupcardPlans,
  );

  const { topupcardCategories } = useSelector(
    (state: RootState) => state.topupcardCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!topupcardCategories || topupcardCategories.length == 0) {
      dispatch(fetchTopupcardCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchTopupcardPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchTopupcardPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleTopupPlanClick = (dataPlan: Product) => {
    setSelectedTopupPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedTopupPlan(null);
  };

  if (showDetailView && selectedTopupPlan) {
    return (
      <TopupcardDetailView
        topupPlan={{
          ...selectedTopupPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <TopupCard
      topupcardPlans={topupcardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onTopupPlanClick={handleTopupPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default ElectricRouter;
